import {Component, Inject, LOCALE_ID} from '@angular/core';
import {Router} from "@angular/router";
import {GlobalService} from "../../../services/global.service";
import {ConfigService} from "../../../services/config.service";

@Component({
  selector: 'app-nowruz-arboriculture',
  standalone: true,
  imports: [],
  templateUrl: './nowruz-arboriculture.component.html',
  styleUrl: './nowruz-arboriculture.component.css'
})
export class NowruzArboricultureComponent {
  constructor(public route: Router,
              @Inject(LOCALE_ID) public locale: string,
              public global: GlobalService,
              public conf: ConfigService) {

  }

}
